module.exports = __webpack_public_path__ + "img/user.992709c2.svg";